<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getWxSign } from '@/service/system'
const wx = window.wx
export default {
  mounted() {
    getWxSign({ params: { url: location.href } }).then((res) => {
      const { data } = res
      wx.config(data)
    })
    wx.ready(function () {
      console.log(11)
      wx.onMenuShareAppMessage({
        title: '速新闻', // 分享标题
        desc: '', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://app.suxinwen.cn/spa/static/imgs/news_share.png', // 分享图标
        success: function () {
          // 设置成功
        }
      })
    })
    wx.error(function (err) {
      console.log(err)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
  }
}
</script>
